import {getCustomerAccounts} from '@account/api';
import {useQuery} from '@tanstack/react-query';

export const useCustomerAccounts = (
  {limit = 20, offset = 0, search = '', id, is_trial, status, sort},
  options = {}
) => {
  const params = {limit, offset, search, id, is_trial, status, sort};

  return useQuery(['ims-accounts', params], () => getCustomerAccounts(params), {
    ...options,
  });
};
